<p>
  candidate-configuration works!
</p>
